import { requireStripeCheckoutUrl } from "./stripe-checkout-url";

export function prepareExternalCheckoutWindow(): Window | null {
  if (typeof window === "undefined") return null;
  try {
    return window.open("/external-checkout", "_blank");
  } catch {
    return null;
  }
}

export function openExternalCheckout(url: string, checkoutWindow?: Window | null) {
  const safeUrl = requireStripeCheckoutUrl(url);
  if (typeof window === "undefined") return;
  if (checkoutWindow && !checkoutWindow.closed) {
    try {
      checkoutWindow.opener = null;
      checkoutWindow.location.replace(safeUrl);
      return;
    } catch {
      closeExternalCheckoutWindow(checkoutWindow);
    }
  }

  // Same-tab fallback also works when an asynchronous response cannot open a popup.
  window.location.assign(`/external-checkout?to=${encodeURIComponent(safeUrl)}`);
}

export function closeExternalCheckoutWindow(checkoutWindow?: Window | null) {
  try {
    if (checkoutWindow && !checkoutWindow.closed) checkoutWindow.close();
  } catch {
    // A closed or cross-origin tab must not mask the original payment error.
  }
}
